import { abortable as abortableBase, encodeFilePath, fileTreeEntriesToSortedNodeData, replaceDoubleSlashWithSingleSlash, } from "@enfusion-ui/utils";
import queryString from "query-string";
import { getFilePath, getRoot } from "./utils/documents";
const baseURL = "/internal/api/documents";
export default (restServer) => {
    const getRootNode = async (root, subRoot) => {
        try {
            const rootData = await restServer(queryString.stringifyUrl({
                url: `${baseURL}/v2/folder`,
                query: {
                    type: `${root}`,
                    root: getRoot(subRoot),
                    path: subRoot.includes("/")
                        ? encodeFilePath(getFilePath(subRoot))
                        : undefined,
                },
            }));
            return rootData?.children
                ? fileTreeEntriesToSortedNodeData(rootData.children)
                : [];
        }
        catch (err) {
            console.error("REMOTE FILE DETAIL ERROR", err);
            throw new Error("Failed to get root node");
        }
    };
    const getSearchRootNode = async (root, subRoot, searchText) => {
        try {
            const rootData = await restServer(queryString.stringifyUrl({
                url: `${baseURL}/file/searches/${subRoot}`,
                query: { type: `${root}`, searchText },
            }));
            return rootData?.children
                ? fileTreeEntriesToSortedNodeData(rootData.children)
                : [];
        }
        catch (err) {
            console.error("REMOTE FILE DETAIL ERROR", err);
            throw new Error("Failed to get root node");
        }
    };
    const abortable = (c) => abortableBase(restServer, c);
    return {
        GET_ROOT_NODE: getRootNode,
        GET_SEARCH_ROOT_NODE: getSearchRootNode,
        GET_ROOT_NODE_FACTORY: (root) => (node) => {
            try {
                const nodePath = typeof node === "string"
                    ? node
                    : node.path;
                return getRootNode(root, `${nodePath}`);
            }
            catch (err) {
                throw new Error("Failed to get root details");
            }
        },
        CREATE_FOLDER: (root, path) => restServer(queryString.stringifyUrl({
            url: replaceDoubleSlashWithSingleSlash(`${baseURL}/v2/folder`),
            query: {
                root: getRoot(path),
                type: `${root}`,
            },
        }), {
            method: "POST",
            body: { path: getFilePath(path) },
        }),
        RENAME_FOLDER: (root, filePath, newFolderName, forceWrite = false) => restServer(queryString.stringifyUrl({
            url: `${baseURL}/v2/file`,
            query: {
                type: `${root}`,
                root: getRoot(filePath),
                newName: newFolderName,
                forceWrite,
            },
        }), {
            method: "PATCH",
            body: {
                path: getFilePath(filePath),
            },
        }),
        DELETE_ENTRY: (root, filePath) => {
            console.log(filePath);
            return restServer(queryString.stringifyUrl({
                url: replaceDoubleSlashWithSingleSlash(`${baseURL}/v2/file`),
                query: {
                    type: `${root}`,
                    root: getRoot(filePath),
                    path: encodeFilePath(getFilePath(filePath)),
                },
            }), { method: "DELETE" });
        },
        MOVE_ENTRY: (root, filePath, destinationFolder, forceWrite = false) => restServer(queryString.stringifyUrl({
            url: replaceDoubleSlashWithSingleSlash(`${baseURL}/v2/file`),
            query: {
                type: `${root}`,
                root: getRoot(filePath),
                newPath: destinationFolder,
                forceWrite,
            },
        }), {
            method: "PUT",
            body: {
                path: getFilePath(filePath),
            },
        }),
        UPLOAD: (root, subRoot, body, mobile) => restServer(queryString.stringifyUrl({
            url: replaceDoubleSlashWithSingleSlash(`${baseURL}/file/${subRoot}`),
            query: { type: root, mobile },
        }), { body }),
        DOWNLOAD: abortable((root, filePath, mobile) => queryString.stringifyUrl({
            url: replaceDoubleSlashWithSingleSlash(`${baseURL}/v2/file`),
            query: {
                root: getRoot(filePath),
                type: `${root}`,
                mobile,
                path: encodeFilePath(getFilePath(filePath)),
            },
        })),
    };
};
